module.exports = __webpack_public_path__ + "img/T1C_xh_4.ccc6bff5.png";